import type { CountryCode } from 'libphonenumber-js';

export const UNMOUNT_TIMEOUT = 500;
export const CLOSE_MODAL_TIMEOUT = 100;
export const TOAST_TIMER = 8000;
export const MAX_TOASTS_ON_PAGE = 5;

export const PROTOCOL = import.meta.env.VITE_PROTOCOL;
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
export const PORT = import.meta.env.VITE_PORT;

export const SQL_NUMBER_FORMAT = '0.0000';

export const URL_CONF_POLICY =
  'https://iidf.ru/upload/documents/frii-invest_policy.pdf';
export const URL_SOGLAS_POLICY =
  'https://iidf.ru/upload/documents/soglas_invest_request.pdf';

export const DEFAULT_COUNTRY_CODE: CountryCode = 'RU';
